export const task = {
  props: {
    task: Object
  },

  data () {
    return {
      loading: false,
      status: {
        // state: 'queued'|'processing'|'complete'
        state: 'queued',
        // number of processed lines of CSV
        completion: 0,
        total: 0
      }
    }
  },

  computed: {
    id () {
      if (this.task !== undefined) {
        return this.task.id
      }
      return this.$route.params.id
    },
    icon () {
      const stateMap = {
        aborted: 'mdi-email-remove',
        complete: 'mdi-email-check',
        failed: 'mdi-email-alert',
        processing: 'mdi-email-sync',
        queued: 'mdi-email'
      }
      return stateMap[this.status.state]
    },
    iconColor () {
      const stateMap = {
        aborted: 'grey',
        complete: 'primary',
        failed: 'error',
        processing: 'info',
        queued: 'grey'
      }
      return stateMap[this.status.state]
    },
    classTextColor () {
      const stateMap = {
        aborted: 'grey--text',
        complete: 'primary--text',
        failed: 'error--text',
        processing: 'info--text',
        queued: 'grey--text'
      }
      return stateMap[this.status.state]
    },
    processing () {
      return this.status.state === 'processing' && this.status.completion < this.status.total
    },
    completed () {
      return this.status.state === 'complete'
    },
    waiting () {
      return this.status.state === 'queued'
    },
    failed () {
      return this.status.state === 'failed'
    },
    aborted () {
      return this.status.state === 'aborted'
    },
    progress () {
      return Math.ceil((this.status.completion * 100) / this.status.total)
    }
  },

  methods: {
    fetchTask () {
      this.loading = true
      const url = process.env.VUE_APP_ROOT_API + '/' + this.id
      this.axios.get(url)
        .then(response => {
          this.status = response.data
          // TODO: If task doesn't exist, add them to store, before updating
          // update task in store
          this.$store.dispatch({
            type: 'updateTaskState',
            id: this.id,
            taskState: response.data.state
          })
          this.loading = false
        })
        .catch(error => {
          this.$log.error(error)
          this.loading = false
        })
    },
    cancelTask () {
      this.loading = true
      const url = process.env.VUE_APP_ROOT_API + '/' + this.id
      this.axios.delete(url)
        .then(response => {
          this.$log.debug(response)
          // this.status = response.data
          // update task in store
          /*
          this.$store.dispatch({
            type: 'updateTaskState',
            id: this.task.id,
            taskState: response.data.state
          })
          */
          this.loading = false
        })
        .catch(error => {
          this.$log.error(error)
          this.loading = false
        })
    },
    removeTask () {
      this.$store.dispatch('deleteTask', this.id)
    },
    fetchStateUnlessFinished () {
      // TODO: It is possible, that tasks are queued if there are no free workers.
      // Therefor tasks which are waiting should only fetch information from backend
      // if there is at least on free worker. NEEDS REFLEXION!
      if (!(this.completed || this.aborted || this.failed)) {
        this.fetchTask()
      }
    }
  },

  mounted () {
    this.fetchTask()
    // fetch status regularly as long as the process is finished
    window.setInterval(
      this.fetchStateUnlessFinished, 500
    )
  }
}

export default task
